import React from "react";
import { CoverSheet } from "./CoverLetter";
import { ResumePageOne, ResumePageTwo } from "./Resume";

/**
 * Combined application: Cover Letter (page 1) → Resume Page 1 (page 2) → Resume Page 2 (page 3)
 * for the Marisa Peer / More Than Enough role.
 *
 * Single "Print / Save PDF" produces ONE 3-page A4 PDF.
 */

const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const Application = () => {
    return (
        <main
            data-testid="application-page"
            style={{
                backgroundColor: "#2a2620",
                minHeight: "100vh",
                padding: "40px 16px 80px",
                fontFamily: SANS,
            }}
        >
            {/* Toolbar — hidden in print */}
            <div
                className="application-toolbar"
                style={{
                    maxWidth: 794,
                    margin: "0 auto 24px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                    flexWrap: "wrap",
                }}
            >
                <div>
                    <p
                        style={{
                            color: "#c9a227",
                            fontSize: 11,
                            letterSpacing: "0.3em",
                            textTransform: "uppercase",
                            margin: 0,
                            fontWeight: 600,
                        }}
                    >
                        Tatva K · Application Pack · 3 pages
                    </p>
                    <p
                        style={{
                            color: "#9a8c70",
                            fontSize: 10,
                            margin: "4px 0 0",
                            letterSpacing: "0.04em",
                        }}
                    >
                        Cover Letter → Resume (p1) → Resume (p2)
                    </p>
                </div>
                <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/api/application/pdf`}
                    download="Tatva-K-Application-Pack.pdf"
                    data-testid="application-download-btn"
                    style={{
                        backgroundColor: "#c9a227",
                        color: "#1a1a1a",
                        border: "none",
                        padding: "12px 26px",
                        fontSize: 11,
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        cursor: "pointer",
                        borderRadius: 999,
                        textDecoration: "none",
                        display: "inline-block",
                    }}
                >
                    Download PDF
                </a>
            </div>

            {/* Page stack — three A4 sheets, one PDF */}
            <CoverSheet />
            <ResumePageOne />
            <ResumePageTwo />

            <style>{`
                @page { size: A4; margin: 0; }
                @media print {
                    body, html { background: #ffffff !important; }
                    main[data-testid="application-page"] {
                        background: #ffffff !important;
                        padding: 0 !important;
                    }
                    .application-toolbar { display: none !important; }
                    .cover-page, .resume-page {
                        box-shadow: none !important;
                        margin: 0 !important;
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                    }
                    .resume-page {
                        page-break-before: always !important;
                        break-before: always !important;
                    }
                    nav, footer[data-testid="site-footer"],
                    [data-testid="floating-whatsapp-btn"],
                    [data-testid="cookie-consent-banner"] { display: none !important; }
                }
            `}</style>
        </main>
    );
};

export default Application;
